import { render, staticRenderFns } from "./resetDafult.vue?vue&type=template&id=6db9c000&scoped=true&"
import script from "./resetDafult.vue?vue&type=script&lang=js&"
export * from "./resetDafult.vue?vue&type=script&lang=js&"
import style0 from "./resetDafult.vue?vue&type=style&index=0&id=6db9c000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9c000",
  null
  
)

export default component.exports